<template>
  <div>
    <the-hero-section :title="title" :imgLink="imgLink" />

    <section id="obras" class="extra-padding grey lighten-4">
      <v-container>
        <v-row>
          <v-col cols="12">
            <div
              class="text-center text-uppercase pa-6 ma-6 error--text"
              v-if="error"
            >
              {{ error }}
            </div>
            <v-timeline v-else :dense="$vuetify.breakpoint.smAndDown">
              <v-timeline-item
                v-for="obra in obras"
                :key="obra.id"
                color="primary"
              >
                <!-- <span slot="opposite">mm/yyyy</span> -->
                <v-card class="elevation-2">
                  <h1 class="pl-4 pt-4 text-h6">{{ obra.title }}</h1>
                  <!-- <v-card-title class="text-xs-h6 text-justify">
                    {{ obra.title }}
                  </v-card-title> -->
                  <v-card-text class="text-justify mt-0 pt-1">
                    {{ obra.description }}
                    <br />
                    <span v-if="obra.plazo_mes > 0">
                      <strong>Plazo: </strong> {{ obra.plazo_mes }} Meses
                      <br />
                    </span>

                    <span v-if="obra.volumen_mt3 > 0">
                      <strong>Volumen: </strong> {{ obra.volumen_mt3 }} Mt3
                      <br />
                    </span>

                    <span v-if="obra.empresa != ''">
                      <strong>Empresa: </strong> {{ obra.empresa }}
                    </span>
                  </v-card-text>
                </v-card>
              </v-timeline-item>
              <infinite-loading @infinite="getObras" class="mt-10">
                <div slot="spinner" class="mt-6">
                  Cargando Obras <v-icon>mdi-spin mdi-loading</v-icon>
                </div>
                <div slot="no-more" class="mt-n10 ">
                  No hay mas Obras
                </div>
                <div
                  slot="no-results"
                  class="mb-n10 pa-10 rounded-lg primary secondary--text text-uppercase"
                >
                  No hay resultados
                </div>
              </infinite-loading>
            </v-timeline>
          </v-col>
        </v-row>
      </v-container>
    </section>
  </div>
</template>

<script>
import InfiniteLoading from "vue-infinite-loading";
import axios from "axios";
export default {
  name: "Obras",
  components: {
    TheHeroSection: () => import("@/components/TheHeroSection"),
    InfiniteLoading
  },
  data: () => ({
    title: "Nuestras Obras",
    imgLink: "section-obras.jpeg",
    page: 1,
    obras: [],
    error: ""
  }),
  // computed: {
  //   getEmpresa (){

  //   }
  // },
  methods: {
    getObras($state) {
      axios
        .get("https://argecam.com.ar/api/obras?page=" + this.page)
        .then(response => {
          if (response.data.data.length) {
            this.page += 1;
            this.obras.push(...response.data.data);
            $state.loaded();
          } else {
            $state.complete();
          }
          // this.obras = response.data.data;
          // console.log(this.obras);
        })
        .catch(() => {
          this.error = "ocurrió un problema! intente de nuevo mas tarde.. ";
        });
    }
  }
};
</script>

<style></style>
